import { UsersState } from "../types/users-state.interface";
import { createUsersState } from "../types/users-state.functions";
import { UsersActions, UsersActionsType } from "./users.actions";

const usersReducer = (state: UsersState = createUsersState(), action: UsersActionsType) => {
  switch (action.type) {
    case UsersActions.SearchUsers:
    case UsersActions.FetchAllUsers:
      return {
        ...state,
        loading: true,
      };
    case UsersActions.SearchUsersSuccess:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
      };
    case UsersActions.ResetSearchResults:
      return {
        ...state,
        loading: false,
        searchResults: [],
      };
    case UsersActions.FetchAllUsersSuccess:
      return {
        ...state,
        loading: false,
        allUsers: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
